import { api as http } from '~/api/services'

export const fetchAllocatorContactProfile = (companyId, contactId) =>
  http.get(`allocators/${contactId}/${companyId}/profile`)
